import * as React from "react";

export const SearchIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
}> = ({ className, size = 24, color = "currentColor" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52832 11.7659C3.52832 7.21587 7.21685 3.52734 11.7669 3.52734C16.3169 3.52734 20.0054 7.21587 20.0054 11.7659C20.0054 16.3159 16.3169 20.0045 11.7669 20.0045C7.21685 20.0045 3.52832 16.3159 3.52832 11.7659ZM11.7669 2.02734C6.38842 2.02734 2.02832 6.38744 2.02832 11.7659C2.02832 17.1444 6.38842 21.5045 11.7669 21.5045C14.0671 21.5045 16.1811 20.707 17.8474 19.3734L21.0129 22.5308C21.3062 22.8233 21.7811 22.8227 22.0736 22.5294C22.3661 22.2361 22.3655 21.7612 22.0722 21.4687L18.9439 18.3485C20.5345 16.6152 21.5054 14.3039 21.5054 11.7659C21.5054 6.38744 17.1453 2.02734 11.7669 2.02734Z"
      fill={color}
    />
  </svg>
);
